// Локальная версия cookie-consent.js
// Использует ресурсы с локального сервера вместо CloudFront

function addKaamelSDK() {
    // Определяем базовый путь в зависимости от окружения
    // В dev режиме (localhost) используем относительные пути, в production - абсолютные
    const isDev = window.location.hostname === 'localhost' || 
                  window.location.hostname === '127.0.0.1' ||
                  window.location.port !== '';
    const basePath = isDev ? './static/cookie-consent' : '/static/cookie-consent';

    // Добавляем CSS ссылку
    const kaamelSDKCssLink = document.createElement('link');
    kaamelSDKCssLink.rel = 'stylesheet';
    kaamelSDKCssLink.type = 'text/css';
    kaamelSDKCssLink.href = `${basePath}/index.min.css`;

    // Добавляем JavaScript скрипт
    const kaamelSDKScript = document.createElement("script");
    kaamelSDKScript.type = "text/javascript";
    kaamelSDKScript.src = `${basePath}/index.min.js`;
    kaamelSDKScript.async = true;
    kaamelSDKScript.onerror = function() {
        console.error("Failed to load the ccm script.");
    };

    // Создаем ccmRoot элемент
    const ccmRoot = document.createElement("div");
    ccmRoot.style.cssText = "position:fixed;left:0;top:0;width:100vw;height:100vh;pointer-events:none;z-index:" + Number.MAX_SAFE_INTEGER;

    // После загрузки страницы добавляем css/js/ccmRoot в body
    document.addEventListener("DOMContentLoaded", function() {
        document.head.appendChild(kaamelSDKCssLink);
        document.head.appendChild(kaamelSDKScript);

        document.body.appendChild(ccmRoot);
    });

    // Слушаем событие загрузки скрипта
    kaamelSDKScript.addEventListener("load", kaamelSDKScriptLoaded, false);

    // Callback функция после загрузки скрипта
    function kaamelSDKScriptLoaded() {
        const extraOptions = {
            privacyCenterUrl: "https://privacy-center.cerebraai.ai/privacy-center.html",
            privacyCenterZhUrl: "",
            companyName: "CerebraAI",
            companyDomain: "https://cerebraai.ai",
            customizePosition: "undefined",
            theme: "undefined",
        }
        
        const ccmDialog = window.kaamelObj.initCookieConsentDialog(ccmRoot, extraOptions);
        
        window.kaamelObj.globalCCMDialog = ccmDialog;
        window.kaamelObj.servicesEffective = ccmDialog.cookieControlEffective;

        window.kaamelObj.addEventListener = function(type, cb) {
            ccmDialog.addEventListener(type, cb);
        };
    }
}

addKaamelSDK();

